import type { Query } from './ApiCaller';

export function getUrlWithQuery(url: string, query?: Query) {
  if (!query) return url;

  const q = Object.keys(query)
    .filter((key) => query[key] != null)
    .map((key) => {
      const value = query[key];
      const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
      return [key, stringValue];
    });

  return `${url}${q.length > 0 ? `?${new URLSearchParams(q).toString()}` : ''}`;
}
